/* eslint-disable no-underscore-dangle */
import React from 'react';
import PropTypes from 'prop-types';
import { Text } from 'office-ui-fabric-react/lib/Text';
import { FontIcon } from 'office-ui-fabric-react/lib/Icon';
import clsx from 'clsx';
import { addHours, format } from 'date-fns';
import DetailsList from '../DetailsList';
import Link from '../Link';
import styles from './DimensionListsTasksList.style';
import appStyles from '../../App.style';

const columns = [
  {
    key: 'Action Required',
    name: 'Action Required',
    isResizable: false,
    isIconOnly: true,
    minWidth: 10,
    maxWidth: 10,
    onRender: (task, index) => (
      <>
        <div className={styles.secondaryIconColumnFlex}>
          <FontIcon
            className={clsx(styles.actionRequiredIcon, appStyles.defaultColor)}
            iconName="StatusCircleExclamation"
            ariaLabel="TextDocument"
            id={`actionRequiredIcon${index}`}
          />
        </div>
      </>
    ),
  },
  {
    key: 'name',
    name: 'List Name',
    fieldName: 'name',
    isResizable: false,
    minWidth: 450,
    maxWidth: 600,
    onRender: task => task.resource?.listName,
  },
  {
    key: 'name',
    name: 'Contract Id',
    fieldName: 'contractId',
    isResizable: false,
    minWidth: 100,
    maxWidth: 100,
    onRender: task =>
      `Due ${format(addHours(new Date(task.lastUpdatedTimestamp), 72), 'MM/dd/yyyy')}`,
  },
  {
    key: 'reviewLink',
    name: 'Review',
    fieldName: 'review',
    isResizable: false,
    minWidth: 150,
    maxWidth: 150,
    className: styles.reviewLink,
    onRender: task => {
      switch (task.operation) {
        case 'submit-for-approval':
          return (
            <div>
              <Link
                href={`dimensionlists/${task.resourceId}/${task.resource.listType}`}
                className={styles.button}
              >
                <Text data-testid={`review-and-approve-${task.resourceId}`}>
                  Review and Approve
                </Text>
                <FontIcon iconName="ChevronRight" className={styles.rightIcon} />
              </Link>
            </div>
          );
        case 'reject':
          return (
            <div>
              <Link href={`dimensionlists/${task.resourceId}/edit`} className={styles.button}>
                <Text data-testid={`review-and-resubmit-${task.resourceId}`}>
                  Review and Resubmit
                </Text>
                <FontIcon iconName="ChevronRight" className={styles.rightIcon} />
              </Link>
            </div>
          );
        default:
          return (
            <div>
              <Link
                href={`dimensionlists/${task.resourceId}/${task.resource.listType}`}
                className={styles.button}
              >
                <Text data-testid={`review-and-approve-${task.resourceId}`}>Wrong</Text>
                <FontIcon iconName="ChevronRight" className={styles.rightIcon} />
              </Link>
            </div>
          );
      }
    },
  },
];

const DimensionListsTasksList = ({ items, className, ...other }) => (
  <DetailsList
    items={items.map(task => {
      return {
        ...task,
        key: task.key,
        dataAutomationId: `row-${task._id}`,
      };
    })}
    columns={columns}
    className={className}
    {...other}
  />
);

DimensionListsTasksList.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      status: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      type: PropTypes.string.isRequired,
      contractId: PropTypes.string,
      dataAutomationId: PropTypes.string,
    }),
  ),
  className: PropTypes.string,
};

DimensionListsTasksList.defaultProps = {
  items: [],
  className: '',
};

export default DimensionListsTasksList;
